module.exports = __webpack_public_path__ + "img/protected-bag-icon-4.3cdd603d.svg";